import { Map, fromJS } from 'immutable'
import _get from 'lodash/get'
import {
  SET_USER_BILLING_SUBSCRIPTION_PROCESSING,
  SET_USER_BILLING_SUBSCRIPTION_DATA,
  SET_USER_BILLING_SUBSCRIPTION_ERROR,
  SET_USER_PAYMENT_HISTORY_PROCESSING,
  SET_USER_PAYMENT_HISTORY_DATA,
  SET_USER_PAYMENT_HISTORY_DATA_ERROR,
  SET_USER_REFUND_PROCESSING,
  SET_USER_REFUND_DATA,
  SET_USER_REFUND_DATA_ERROR,
  RESET_USER_REFUND,
  SET_USER_REFUND_DOWNGRADE_PROCESSING,
  SET_USER_REFUND_DOWNGRADE_DATA,
  SET_USER_REFUND_DOWNGRADE_DATA_ERROR,
  RESET_USER_REFUND_DOWNGRADE,
  SET_USER_REFUND_CANCEL_PROCESSING,
  SET_USER_REFUND_CANCEL_DATA,
  SET_USER_REFUND_CANCEL_DATA_ERROR,
  RESET_USER_REFUND_CANCEL,
  SET_USER_COMP_PROCESSING,
  SET_USER_COMP_DATA,
  SET_USER_COMP_ERROR,
  RESET_USER_COMP,
  SET_USER_CANCEL_SUBSCRIPTION_PROCESSING,
  SET_USER_CANCEL_SUBSCRIPTION_DATA,
  SET_USER_CANCEL_SUBSCRIPTION_ERROR,
  RESET_USER_REACTIVATE_SUBSCRIPTION,
  SET_USER_REACTIVATE_SUBSCRIPTION_PROCESSING,
  SET_USER_REACTIVATE_SUBSCRIPTION_DATA,
  SET_USER_REACTIVATE_SUBSCRIPTION_ERROR,
  RESET_USER_CANCEL_SUBSCRIPTION,
  SET_USER_REMOVE_PAYMENT_METHODS_PROCESSING,
  SET_USER_REMOVE_PAYMENT_METHODS_DATA,
  SET_USER_REMOVE_PAYMENT_METHODS_ERROR,
  RESET_USER_REMOVE_PAYMENT_METHODS,
  SET_PLANS_PROCESSING,
  SET_PLANS_DATA,
  SET_PLANS_ERROR,
  SET_USER_PLAN_CHANGE_PROCESSING,
  SET_USER_PLAN_CHANGE_DATA,
  SET_USER_PLAN_CHANGE_ERROR,
  RESET_USER_PLAN_CHANGE,
  SET_USER_UPDATE_PAYMENT_METHOD_PROCESSING,
  SET_USER_UPDATE_PAYMENT_METHOD_DATA,
  SET_USER_UPDATE_PAYMENT_METHOD_ERROR,
  RESET_USER_UPDATE_PAYMENT_METHOD,
  SET_PAYMENT_TOKEN_PROCESSING,
  SET_PAYMENT_TOKEN_DATA,
  SET_PAYMENT_TOKEN_ERROR,
  RESET_PAYMENT_TOKEN,
  SET_PAYMENT_BILLING_DATA,
  SET_USER_CURRENCY_CHANGE_ERROR,
  SET_USER_CURRENCY_CHANGE_PROCESSING,
  SET_USER_CURRENCY_CHANGE_DATA,
  SET_USER_CURRENCY_CHANGE_POLLING,
  RESET_USER_CURRENCY_CHANGE,
  SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING,
  SET_USER_ACCOUNT_INVOICE_HISTORY_DATA,
  SET_USER_ACCOUNT_INVOICE_HISTORY_DATA_ERROR,
  SET_USER_ACCOUNT_INVOICE_PROCESSING,
  SET_USER_ACCOUNT_INVOICE_DATA,
  SET_USER_ACCOUNT_INVOICE_DATA_ERROR,
  SET_USER_ADJUST_PRICE_ERROR,
  SET_USER_ADJUST_PRICE_PROCESSING,
  SET_USER_ADJUST_PRICE_DATA,
  RESET_USER_ADJUST_PRICE,
  SET_USER_PAUSE_SUBSCRIPTION_PROCESSING,
  SET_USER_PAUSE_SUBSCRIPTION_DATA,
  SET_USER_PAUSE_SUBSCRIPTION_ERROR,
  SET_USER_RESUME_SUBSCRIPTION_PROCESSING,
  SET_USER_RESUME_SUBSCRIPTION_DATA,
  SET_USER_RESUME_SUBSCRIPTION_ERROR,
  RESET_USER_PAUSE_RESUME,
  SET_USER_SUBSCRIPTION_PAUSE_INFO_PROCESSING,
  SET_USER_SUBSCRIPTION_PAUSE_INFO_DATA,
  SET_USER_SUBSCRIPTION_PAUSE_INFO_ERROR,
  RESET_USER_SUBSCRIPTION_PAUSE_INFO,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_USER_BILLING_SUBSCRIPTION_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_BILLING_SUBSCRIPTION_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_BILLING_SUBSCRIPTION_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_PAYMENT_HISTORY_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_PAYMENT_HISTORY_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_PAYMENT_HISTORY_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_REFUND_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_REFUND_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_REFUND_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_REFUND:
      return state.delete(payload.storeKey)
    case SET_USER_REFUND_CANCEL_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_REFUND_CANCEL_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_REFUND_CANCEL_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_REFUND_CANCEL:
      return state.delete(payload.storeKey)
    case SET_USER_REFUND_DOWNGRADE_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_REFUND_DOWNGRADE_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_REFUND_DOWNGRADE_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: payload.success,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_REFUND_DOWNGRADE:
      return state.delete(payload.storeKey)
    case SET_USER_COMP_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_COMP_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_COMP_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_COMP:
      return state.delete(payload.storeKey)
    case SET_USER_CANCEL_SUBSCRIPTION_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_CANCEL_SUBSCRIPTION_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_CANCEL_SUBSCRIPTION_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_CANCEL_SUBSCRIPTION:
      return state.delete(payload.storeKey)
    case SET_USER_REACTIVATE_SUBSCRIPTION_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_REACTIVATE_SUBSCRIPTION_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_REACTIVATE_SUBSCRIPTION_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_REACTIVATE_SUBSCRIPTION:
      return state.delete(payload.storeKey)
    case SET_USER_REMOVE_PAYMENT_METHODS_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_REMOVE_PAYMENT_METHODS_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_REMOVE_PAYMENT_METHODS_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_REMOVE_PAYMENT_METHODS:
      return state.delete(payload.storeKey)
    case SET_PLANS_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_PLANS_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_PLANS_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_CURRENCY_CHANGE_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case RESET_USER_CURRENCY_CHANGE:
      return state.delete(payload.storeKey)
    case SET_USER_CURRENCY_CHANGE_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_CURRENCY_CHANGE_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_CURRENCY_CHANGE_POLLING:
      return state.setIn([payload.storeKey, 'polling'], payload.polling)
    case SET_USER_ACCOUNT_INVOICE_HISTORY_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_ACCOUNT_INVOICE_HISTORY_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          fromJS({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_ACCOUNT_INVOICE_HISTORY_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          fromJS({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_ACCOUNT_INVOICE_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_ACCOUNT_INVOICE_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          fromJS({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_ACCOUNT_INVOICE_DATA_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          fromJS({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_PLAN_CHANGE_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_PLAN_CHANGE_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_PLAN_CHANGE_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_PLAN_CHANGE:
      return state.delete(payload.storeKey)
    case SET_USER_UPDATE_PAYMENT_METHOD_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_UPDATE_PAYMENT_METHOD_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_UPDATE_PAYMENT_METHOD_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_UPDATE_PAYMENT_METHOD:
      return state.delete(payload.storeKey)
    case SET_PAYMENT_TOKEN_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_PAYMENT_TOKEN_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            token: _get(payload, 'data', null),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_PAYMENT_TOKEN_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            token: null,
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_PAYMENT_TOKEN:
      return state.delete(payload.storeKey)
    case SET_PAYMENT_BILLING_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            billing: fromJS(_get(payload, 'data', {})),
          }),
        ),
      )
    case SET_USER_ADJUST_PRICE_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_ADJUST_PRICE_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_ADJUST_PRICE_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_ADJUST_PRICE:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case SET_USER_PAUSE_SUBSCRIPTION_PROCESSING:
    case SET_USER_RESUME_SUBSCRIPTION_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_PAUSE_SUBSCRIPTION_DATA:
    case SET_USER_RESUME_SUBSCRIPTION_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_PAUSE_SUBSCRIPTION_ERROR:
    case SET_USER_RESUME_SUBSCRIPTION_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_PAUSE_RESUME:
      return state.delete(payload.storeKey)
    case SET_USER_SUBSCRIPTION_PAUSE_INFO_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_SUBSCRIPTION_PAUSE_INFO_DATA:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: true,
            data: _get(payload, 'data', Map()),
            processing: payload.processing,
            error: null,
          }),
        ),
      )
    case SET_USER_SUBSCRIPTION_PAUSE_INFO_ERROR:
      return state.update(payload.storeKey, (value) =>
        value.merge(
          Map({
            success: false,
            data: Map(),
            processing: payload.processing,
            error: payload.error,
          }),
        ),
      )
    case RESET_USER_SUBSCRIPTION_PAUSE_INFO:
      return state.delete(payload.storeKey)
    default:
      return state
  }
}
